import { useLocation } from 'react-router-dom';

export const usePaths = () => {
    const { pathname } = useLocation()
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, ...rest] = pathname.split('/')
    return rest
}